import { render, staticRenderFns } from "./Number.vue?vue&type=template&id=caf2a91a&"
import script from "./Number.vue?vue&type=script&lang=ts&"
export * from "./Number.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports